// extracted by mini-css-extract-plugin
export default {"Container":"SettingPage_Container__EpXo3","Setting":"SettingPage_Setting__83qn6","BackButton":"SettingPage_BackButton__yFRvu"};